module.exports = __webpack_public_path__ + "img/winter3.23bdfbd5.jpeg";